import { devices } from '@helpers/utils.js';
import {
  MediaReplaceButton,
  MediaRemoveButton,
} from '@components/media-upload';

const {
  i18n: { __ },
  blockEditor: { MediaUpload, MediaUploadCheck },
  components: { PanelBody, Button },
} = wp;

const ImageAsBackground = ({ imageAsBackgroundOptions, setAttributes }) => {
  const changeBackgroundImage = (
    url,
    alt,
    paramDeviceType,
    paramImageAsBackgroundOptions,
  ) => {
    setAttributes({
      imageAsBackgroundOptions: {
        ...paramImageAsBackgroundOptions,
        [paramDeviceType]: {
          ...imageAsBackgroundOptions[paramDeviceType],
          settings: {
            ...paramImageAsBackgroundOptions[paramDeviceType].settings,
            url,
            alt,
          },
        },
      },
    });
  };

  return (
    <>
      {devices.map((device, index) => {
        const deviceType = device.type;
        const deviceLabel = device.label;
        const { url, alt } = imageAsBackgroundOptions[deviceType].settings;

        return (
          <PanelBody
            title={deviceLabel}
            initialOpen={index === 0}
            key={deviceType}
          >
            <MediaUploadCheck>
              <MediaUpload
                allowedType={['image']}
                value={url}
                onSelect={(img) => {
                  const { url = '', alt = '' } = img;
                  changeBackgroundImage(
                    url,
                    alt,
                    deviceType,
                    imageAsBackgroundOptions,
                  );
                }}
                render={({ open }) => (
                  <div className="media-upload image-upload">
                    {url && (
                      <div className="upload-buttons-wrapper">
                        <MediaReplaceButton onClick={open} />
                        <MediaRemoveButton
                          onClick={() => {
                            changeBackgroundImage(
                              '',
                              '',
                              deviceType,
                              imageAsBackgroundOptions,
                            );
                          }}
                        />
                      </div>
                    )}
                    {!url && (
                      <Button
                        className="media-button upload-button"
                        onClick={open}
                      >
                        {__('Upload Image', 'b3rg')}
                      </Button>
                    )}
                    {url && (
                      <div
                        className="image-thumb-wrapper"
                        onClick={open}
                        onKeyUp={open}
                        role="button"
                        tabIndex="0"
                      >
                        <img className="image-thumb" src={url} alt={alt} />
                      </div>
                    )}
                  </div>
                )}
              ></MediaUpload>
            </MediaUploadCheck>
          </PanelBody>
        );
      })}
    </>
  );
};

export default ImageAsBackground;
